import ApiClient from './ApiClient';

// Global (not account-scoped) resource — the pool of WhatsApp Embedded
// Signup apps is shared across the whole installation, so this deliberately
// omits `{ accountScoped: true }` to hit /api/v1/whatsapp_meta_apps
// directly instead of /api/v1/accounts/:accountId/whatsapp_meta_apps.
class WhatsappMetaAppAPI extends ApiClient {
  constructor() {
    super('whatsapp_meta_apps');
  }
}

export default new WhatsappMetaAppAPI();
